import {
  Popover,
  PopoverBody,
  PopoverArrow,
  PopoverTrigger,
  PopoverContent,
  PopoverCloseButton,
} from '@chakra-ui/react';
import { useColorValue } from '~/hooks';

import type { PromptProps } from './types';

export const DesktopPrompt = (props: PromptProps): JSX.Element => {
  const { trigger, children, ...disclosure } = props;
  const bg = useColorValue('white', 'gray.900');
  const borderColor = useColorValue('gray.200', 'gray.700');

  return (
    <Popover closeOnBlur={false} {...disclosure}>
      <PopoverTrigger>{trigger}</PopoverTrigger>
      <PopoverContent bg={bg} borderColor={borderColor} w="max-content" minW="360px" maxW="md">
        <PopoverArrow bg={bg} borderColor={borderColor} />
        <PopoverCloseButton />
        <PopoverBody p={6}>{children}</PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
